import React from "react";

const ResendIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="resend_icon"
      data-name="resend"
      {...props}
      width={props.width || "25"}
      height={props.height || "24"}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 4H2C0.897 4 0 4.897 0 6V18C0 19.103 0.897 20 2 20H18C19.103 20 20 19.103 20 18V6C20 4.897 19.103 4 18 4ZM18 6V6.511L10 12.734L2 6.512V6H18ZM2 18V9.044L9.386 14.789C9.56111 14.9265 9.77733 15.0013 10 15.0013C10.2227 15.0013 10.4389 14.9265 10.614 14.789L18 9.044L18.002 18H2Z"
        fill={props.fill || "#4CAF50"}
      />
      <g clipPath="url(#clip0_1045_6452)">
        <rect
          x="10.668"
          y="9"
          width="13"
          height="13"
          rx="6.5"
          fill={props.fill || "#4CAF50"}
        />
        <path
          d="M15.868 14.837H13.9836L13.9843 14.831C14.0691 14.4069 14.2353 14.0041 14.4731 13.6457C14.827 13.1136 15.3234 12.6966 15.9031 12.4445C16.0994 12.3596 16.3041 12.2946 16.5128 12.2515C16.9456 12.1619 17.3916 12.1619 17.8245 12.2515C18.4465 12.3815 19.0173 12.6955 19.4657 13.1542L20.3861 12.2176C19.9713 11.7942 19.4805 11.4562 18.9405 11.2221C18.6651 11.1031 18.3788 11.0124 18.0858 10.9514C17.4812 10.8261 16.858 10.8261 16.2534 10.9514C15.9602 11.0127 15.6736 11.1036 15.398 11.2227C14.5859 11.5743 13.8906 12.158 13.396 12.9035C13.0631 13.4062 12.8304 13.9707 12.7109 14.565C12.6927 14.6546 12.683 14.7461 12.67 14.837H10.668L13.268 17.4901L15.868 14.837ZM18.468 16.1635H20.3523L20.3517 16.1688C20.1818 17.019 19.6908 17.7668 18.9847 18.2502C18.6336 18.4931 18.2388 18.6626 17.8232 18.749C17.3906 18.8386 16.9447 18.8386 16.5121 18.749C16.0965 18.6624 15.7018 18.4929 15.3506 18.2502C15.1781 18.1312 15.017 17.9957 14.8696 17.8456L13.9505 18.7835C14.3655 19.2068 14.8565 19.5446 15.3967 19.7784C15.6723 19.8978 15.9603 19.9887 16.2515 20.0491C16.8558 20.1745 17.4788 20.1745 18.0832 20.0491C19.2483 19.8023 20.2732 19.1015 20.9399 18.0957C21.2725 17.5934 21.505 17.0293 21.6244 16.4355C21.6419 16.3459 21.6523 16.2544 21.6653 16.1635H23.668L21.068 13.5104L18.468 16.1635Z"
          fill="white"
        />
      </g>
      <rect x="10.168" y="8.5" width="14" height="14" rx="7" stroke="white" />
      <defs>
        <clipPath id="clip0_1045_6452">
          <rect x="10.668" y="9" width="13" height="13" rx="6.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ResendIcon;
